// 견적서 라벨·공급자 정보.
// 화면(EstimateWritePage)과 PDF 생성기가 같은 값을 써야 해서 여기 한 곳에 둔다.
// 페이지 안에 두면 서버에서 PDF를 다시 만들 때 값을 복사하게 되고, 곧 어긋난다.

export const SUPPLIER = {
  ko: {
    name: '주식회사 프린만',
    ceo: '김창호',
    bizRegNo: '648-87-03509',
    address: '서울시 영등포구 양평로21가길 19, B동 313호',
    bizType: '서비스',
    bizItem: '3D프린터제작',
    phone: '1844-2569',
    bank: '하나은행  149-910028-93104',
  },
  en: {
    name: 'Prinmann Co., Ltd.',
    ceo: 'Chang-ho Kim',
    bizRegNo: '648-87-03509',
    address: '19, Yangpyeong-ro 21ga-gil, Yeongdeungpo-gu, Seoul',
    bizType: 'Service',
    bizItem: '3D Printer Manufacturing',
    phone: '+82-1844-2569',
    bank: 'Hana Bank  149-910028-93104',
  },
};

/* ── 라벨 (한/영) ── */
export const L = {
  ko: {
    docTitle: '견  적  서',
    no: '견적번호',
    date: '작성일',
    billTo: 'BILL TO',
    issuedBy: 'ISSUED BY',
    f_name: '상호',
    f_bizNo: '사업자번호',
    f_address: '주소',
    f_contact: '담당자',
    f_ceo: '대표자',
    f_regNo: '등록번호',
    f_bizType: '업태',
    f_bizItem: '종목',
    f_phone: '대표전화',
    th: ['구분', '품목명', '규격', '수량', '단위', '수량', '단위', '단가', '금액', '비고'],
    subtotal: '공급가액',
    sum: '합  계',
    vat: '부가세 (10%)',
    total: '총  계',
    memo: '메모 / 특이사항',
    vatLabel: '부가세 포함',
    defaultTitle: '아래와 같이 견적합니다.',
    addItem: '+ 품목 추가',
    bank: '입금계좌',
    curr: (n) => `${Number(n || 0).toLocaleString()}원`,
  },
  en: {
    docTitle: 'QUOTATION',
    no: 'No.',
    date: 'Date',
    billTo: 'BILL TO',
    issuedBy: 'ISSUED BY',
    f_name: 'Company',
    f_bizNo: 'Business No.',
    f_address: 'Address',
    f_contact: 'Contact',
    f_ceo: 'CEO',
    f_regNo: 'Business Reg. No.',
    f_bizType: 'Industry',
    f_bizItem: 'Category',
    f_phone: 'Tel.',
    th: ['Type', 'Description', 'Spec.', 'Qty', 'Unit', 'Qty', 'Unit', 'Unit Price', 'Amount', 'Notes'],
    subtotal: 'Subtotal',
    sum: 'Sum',
    vat: 'VAT (10%)',
    total: 'TOTAL',
    memo: 'Notes',
    vatLabel: 'Include VAT',
    defaultTitle: 'We are pleased to present our quotation.',
    addItem: '+ Add Item',
    bank: 'Bank Account',
    curr: (n) => `${Number(n || 0).toLocaleString()} won`,
  },
};
